// extracted by mini-css-extract-plugin
export default {"content":"priceListContainer_content__zhSz0","newPriceButton":"priceListContainer_newPriceButton__3SL-+"};